module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-quickspin-off-up@2x.png?0.0.53";